/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createContext, useCallback, useContext, useState } from 'react';

import { Toast } from '../components/Toast';

type TSeverity = 'success' | 'error' | 'warning' | 'info';

interface IToast {
  id?: number;
  severity: TSeverity;
  description?: string;
  title?: string;
}

interface ToastContextValue {
  showToast(data: IToast): void;
}

export const ToastContext = createContext({} as ToastContextValue);

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [toastData, setToastData] = useState<IToast>({} as IToast);

  const showToast = useCallback((data: Omit<IToast, 'id'>) => {
    setToastData({ ...data, id: Date.now() });
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      <Toast
        id={toastData.id}
        severity={toastData?.severity}
        description={toastData?.description}
        title={toastData?.title}
      />
      {children}
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);
